<script>
    import './loader.css';
    import {isLoaderActive} from "../../store";
    let loaderGif = "./images/loader.gif";

</script>
<div class="loader flex items-center flex-text-center {$isLoaderActive ? '': 'hidden'}">
    <img src={loaderGif} alt="Loading..." />
</div>